import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../config/config";

// 🔧 Chuyển từ base64 sang Uint8Array (bắt buộc cho PushManager)
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

const Subcriber = () => {
  const [vapidKey, setVapidKey] = useState(null);

  useEffect(() => {
    const getVapidKey = async () => {
      try {
        const response = await axios.get(`${config.backendUrl}/api/webpush/vapid-public-key`);
        setVapidKey(response.data.publicKey);
      } catch (error) {
        console.error('Lỗi khi lấy VAPID key:', error);
      }
    };
    getVapidKey();
  }, []);

  const handleSubscribe = async () => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      alert("Trình duyệt không hỗ trợ Push Notification");
      return;
    }
    if (!vapidKey) {
      alert("Chưa lấy được VAPID key, vui lòng thử lại.");
      return;
    }

    try {
      // 1. Đăng ký service worker
      const registration = await navigator.serviceWorker.register("/sw.js");
      console.log("✅ Đăng ký Service Worker thành công");

      // 2. Đăng ký với PushManager
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });

      console.log("📦 Subscription:", subscription);

      // 3. Gửi về backend
      await axios.post(`${config.backendUrl}/api/webpush/subscribe`, subscription, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      alert("🎉 Đăng ký nhận thông báo thành công!");
    } catch (err) {
      console.error("❌ Lỗi đăng ký push:", err);
      alert("Không thể đăng ký thông báo.");
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Đăng ký nhận thông báo</h1>
      <button onClick={handleSubscribe} disabled={!vapidKey}>
        🔔 Bật thông báo
      </button>
    </div>
  );
};

export default Subcriber;
